import { useEffect } from 'react';
import { usePopperTooltip } from 'react-popper-tooltip';
import { useNavigate } from 'react-router-dom';

import { MenuSubItem } from 'types';

import styles from '../../styles.module.css';

interface Props {
  storeItems: MenuSubItem[];
  closeMenu: () => void;
  brandDisplay: string;
  storeDisplay: string;
  showStoreSelection: boolean;
  isAdmin: boolean;
}

export function ChangeStoreHover({
  storeItems,
  closeMenu,
  brandDisplay,
  storeDisplay,
  showStoreSelection,
  isAdmin,
}: Props) {
  const navigate = useNavigate();
  const { getTooltipProps, setTooltipRef, setTriggerRef, visible } =
    usePopperTooltip({
      trigger: 'hover',
      offset: [0, 0],
      interactive: true,
      placement: 'right',
    });

  const handleClick = (action?: () => void) => {
    if (action) {
      action();
      closeMenu();

      if (isAdmin) navigate('/');
    }
  };

  const renderStoreItem = ({
    title,
    action,
    isSelected,
    subItemList,
  }: MenuSubItem) => {
    if (isAdmin) {
      return (
        <button
          data-scrollable={isSelected ? 'selected' : ''}
          onClick={() => handleClick(action)}
          className={`text-start cursor-pointer py-3 px-4 text-sm font-bold text-neutral-100
            ${isSelected ? 'bg-primary-300/50' : 'hover:bg-neutral-400 bg-transparent'}`}
        >
          {title}
        </button>
      );
    }

    return (
      <>
        <span className="py-3 px-4 text-sm font-bold">{title}</span>
        {subItemList &&
          subItemList.map(({ title, action, isSelected }) => (
            <button
              data-scrollable={isSelected ? 'selected' : ''}
              key={title}
              onClick={() => handleClick(action)}
              className={`text-start cursor-pointer py-3 px-4 text-sm text-neutral-100
              ${isSelected ? 'bg-primary-300/50' : 'hover:bg-neutral-400 bg-transparent'}`}
            >
              {title}
            </button>
          ))}
      </>
    );
  };

  useEffect(() => {
    if (!visible) return;

    const elStores = document.querySelectorAll('[data-scrollable="selected"]');

    if (elStores.length) {
      const elSelectedStore = elStores[0];

      elSelectedStore.scrollIntoView({ block: 'center' });
    }
  }, [visible]);

  return (
    <div className="hidden md:block group">
      <div
        ref={setTriggerRef}
        className={`flex flex-col items-center justify-center h-16 w-16 ${ showStoreSelection &&
          'group-hover:bg-neutral-500' }`}
      >
        <span className="text-sm font-bold">{brandDisplay}</span>
        {!isAdmin && <span className="text-sm font-bold">{storeDisplay}</span>}
      </div>

      {visible && showStoreSelection && (
        <div
          ref={setTooltipRef}
          {...getTooltipProps()}
          className="overflow-hidden rounded-r max-h-96 flex"
        >
          <div className="flex flex-col bg-neutral-500 w-72 overflow-hidden">
            <span className="text-base font-bold px-4 py-3 border-b border-solid border-b-neutral-400/50">
              {isAdmin ? 'Selecione a marca' : 'Selecione a loja'}
            </span>

            <div
              className={`flex flex-col overflow-y-scroll ${styles.menuScrollbar}`}
            >
              {storeItems.map(item => (
                <div className="flex flex-col" key={item.title}>
                  {renderStoreItem(item)}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
